<template>
    <client-page class="wrap--products">
        <div class="container">
            <div class="join-container">
                <div class="join-complete">
                    <i class="icon icon-handshake"></i>
                    <h3 class="join-complete__title">회원가입이 완료 되었습니다.</h3>
                    <p class="join-complete__text mt-8 mt-md-14 white-space-pre-line">{{ description }}</p>
                    <v-btn x-large color="primary" class="mt-16 mt-md-28"> 메인으로 이동 </v-btn>
                </div>
            </div>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";

import { USER_TYPES } from "@/assets/variables";

export default {
    components: {
        ClientPage,
    },
    computed: {
        code() {
            return this.$route.query.code || USER_TYPES.PERSON.value;
        },
        description() {
            switch (this.code) {
                case USER_TYPES.COMPANY.value: {
                    return "관리자 승인 후 기업서비스를 이용하실 수 있습니다\n1~2 영업일 이내에 승인여부를 확인 하실 수 있습니다";
                }
                default: {
                    return "대시보드에서 추가 정보를 입력해주세요";
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .white-space-pre-line {
        white-space: pre-line;
    }
}
</style>